const OPT_IN = 'OPT_IN';
const OPT_OUT = 'OPT_OUT';
export const Video2OptInStatusTypes = {
  OPT_IN,
  OPT_OUT
};